import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __, sprintf } from '@wordpress/i18n';
import { BlockIcon } from '@wordpress/block-editor';

function DownloadableBlockIcon(_ref) {
  var icon = _ref.icon,
      title = _ref.title;
  return createElement("div", {
    className: "block-directory-downloadable-block-icon"
  }, icon.match(/\.(jpeg|jpg|gif|png|svg)(?:\?.*)?$/) !== null ? createElement("img", {
    src: icon,
    alt: sprintf( // translators: %s: Name of the plugin e.g: "Akismet".
    __('%s block icon'), title)
  }) : createElement(BlockIcon, {
    icon: icon,
    showColors: true
  }));
}

export default DownloadableBlockIcon;
//# sourceMappingURL=index.js.map